import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { useAppSelector } from '../useStore';

export const useRestoreScrollY = () => {
  const { pathname } = useLocation();

  const scrollYStates = useAppSelector((state) => state.scrollY);

  useEffect(() => {
    if (pathname === pageInfo.homePage.path) {
      window.scrollTo(0, scrollYStates.homePageScrollY);
    } else if (pathname === pageInfo.infoListPage.path) {
      window.scrollTo(0, scrollYStates.infoListPageScrollY);
    } else if (pathname === pageInfo.productListPage.path) {
      window.scrollTo(0, scrollYStates.productListPageScrollY);
    } else if (pathname === pageInfo.openMarketListPage.path) {
      window.scrollTo(0, scrollYStates.openMarketListPageScrollY);
    } else if (pathname === '/event-2024-02') {
      window.scrollTo(0, scrollYStates.event202402ScrollY);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
};
